import React, { useCallback, useContext, useRef } from 'react';
import { Form, FormSpy } from 'react-final-form';
import { createForm } from 'final-form';
import { Grid, makeStyles } from '@material-ui/core';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import { TextField } from 'mui-rff';
import { fieldLengthValidator } from '../../../core/utils';
import { CreationInvestorContext } from './CreationInvestorContext';
import { isEmpty } from 'lodash';
import InvestorApi from '../../../core/apis/InvestorApi';
import { useNotify } from 'react-admin';
import { matchingFields } from '../../splitmethods/SplitMethodTypeLookups';

const maxFieldLength = 255;
const matchingField2MaxLength = 256;

const useStyle = makeStyles({
  formGroup: {
    marginBlock: '16px'
  }
});

const MatchingFieldsStep = ({ handleClose }) => {
  const classes = useStyle();
  const notifyServerError = useNotifyServerError();
  const notify = useNotify();
  const { investorContext, setInvestorContext } = useContext(
    CreationInvestorContext
  );

  const onSubmit = useCallback(
    async formValues => {
      if (!isEmpty(formValues)) {
        const {
          externalId1,
          externalId2,
          externalId3,
          externalId4,
          externalId5
        } = formValues;
        const payload = {
          ...investorContext.investor,
          externalId1,
          externalId2,
          externalId3,
          externalId4,
          externalId5
        };

        InvestorApi.updateInvestor(investorContext.investor.id, payload)
          .then(() => {
            handleClose();
            notify('ra.notification.created_investor_successful');
          })
          .catch(e => notifyServerError(e, undefined));
      }
      handleClose();
      notify('ra.notification.created_investor_successful');
    },
    [handleClose, notify, notifyServerError, investorContext.investor]
  );

  const formRef = useRef(
    createForm({
      onSubmit: onSubmit
    })
  );

  return (
    <Form form={formRef.current}>
      {({ handleSubmit, submitting }) => (
        <>
          <FormSpy
            subscription={{ submitting: true, valid: true }}
            onChange={props => {
              setInvestorContext({
                ...investorContext,
                matchingFieldFormState: props
              });
            }}
          />
          <form onSubmit={handleSubmit} id="matchingFieldsForm" noValidate>
            <Grid container>
              <Grid item xs={12} className={classes.formGroup}>
                <TextField
                  name="externalId1"
                  label={matchingFields[0].name}
                  fieldProps={{
                    validate: fieldLengthValidator(maxFieldLength)
                  }}
                  disabled={submitting}
                />
              </Grid>
              <Grid item xs={12} className={classes.formGroup}>
                <TextField
                  name="externalId5"
                  label={matchingFields[4].name}
                  fieldProps={{
                    validate: fieldLengthValidator(maxFieldLength)
                  }}
                  disabled={submitting}
                />
              </Grid>
              <Grid item xs={12} className={classes.formGroup}>
                <TextField
                  name="externalId2"
                  label={matchingFields[1].name}
                  fieldProps={{
                    validate: fieldLengthValidator(matchingField2MaxLength)
                  }}
                  disabled={submitting}
                />
              </Grid>
              <Grid item xs={12} className={classes.formGroup}>
                <TextField
                  name="externalId3"
                  label={matchingFields[2].name}
                  fieldProps={{
                    validate: fieldLengthValidator(maxFieldLength)
                  }}
                  disabled={submitting}
                />
              </Grid>
              <Grid item xs={12} className={classes.formGroup}>
                <TextField
                  name="externalId4"
                  label={matchingFields[3].name}
                  fieldProps={{
                    validate: fieldLengthValidator(maxFieldLength)
                  }}
                  disabled={submitting}
                />
              </Grid>
            </Grid>
          </form>
        </>
      )}
    </Form>
  );
};

export default MatchingFieldsStep;
